import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-sm">
      <Link
        to="/"
        className="flex cursor-pointer items-center gap-1 text-foreground-500 transition-colors hover:text-primary-700"
      >
        <i className="ri-home-4-line"></i>
        <span>首页</span>
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-2 text-foreground-500">
          <i className="ri-arrow-right-s-line text-base text-background-400"></i>
          {item.path ? (
            <Link
              to={item.path}
              className="cursor-pointer transition-colors hover:text-primary-700"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}